module.exports = __webpack_public_path__ + "static/media/notification-success.aaea53e6.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/notification-success.mp3
// module id = 1572
// module chunks = 0